import { PAYMENT_TYPES } from 'constants/enums'

export const steps = {
  welcome: {
    id: 1,
    label: 'Welcome',
    intlKey: 'wizard.welcome',
    completed: false,
    active: true,
    path: '/welcome',
    next: '/level',
    allowedPaths: ['', '/language', '/level']
  },
  language: {
    id: 2,
    label: 'Language',
    intlKey: 'wizard.language',
    completed: false,
    active: false,
    path: '/language',
    next: '/level',
    allowedPaths: ['/welcome', '/level']
  },
  level: {
    id: 3,
    label: 'Award Level',
    intlKey: 'wizard.level',
    completed: false,
    active: true,
    path: '/level',
    next: '/contacts',
    allowedPaths: ['/welcome', 'language', '/contacts']
  },
  contacts: {
    id: 4,
    label: 'Contacts',
    intlKey: 'wizard.contacts',
    completed: false,
    active: true,
    path: '/contacts',
    next: '/details',
    allowedPaths: ['/level', '/details']
  },
  details: {
    id: 5,
    label: 'Participant details',
    intlKey: 'wizard.participant_details',
    completed: false,
    active: true,
    path: '/details',
    next: '/payment',
    allowedPaths: ['/payment', '/account', '/profile', '/parent', '/contacts']
  },
  parent: {
    id: 6,
    label: 'Parent consent',
    intlKey: 'wizard.parent_consent',
    completed: false,
    active: false,
    path: '/parent',
    next: '/payment',
    allowedPaths: ['/payment', '/profile', '/details', '/account']
  },
  profile: {
    id: 7,
    label: 'Profile question',
    intlKey: 'wizard.profile',
    completed: false,
    active: false,
    path: '/profile',
    next: '/payment',
    allowedPaths: ['/details', '/parent', '/payment', '/account']
  },
  payment: {
    id: 8,
    label: 'Payment',
    intlKey: 'wizard.payment',
    completed: false,
    active: false,
    path: '/payment',
    next: '/account',
    allowedPaths: ['/details', '/parent', '/profile', '/account']
  },
  account: {
    id: 9,
    label: 'ORB Account',
    intlKey: 'wizard.orb_account',
    completed: false,
    active: true,
    path: '/account',
    next: '/success',
    allowedPaths: ['/payment', '/profile', '/parent', '/details', '/success', '//mpg-init/*', '//paypal-init/*', '//gp-init/*', '//gp-wp-init/*']
  }
}

export const rootPath = '/register/participant'

export const allowedPaymentKeys = [
  'directPaymentEnabled',
  'exemptFromPaymentEnabled',
  'onlineManualPaymentEnabled',
  'onlineMastercardPaymentEnabled',
  'onlinePayPalPaymentEnabled',
  'onlineGPPaymentEnabled',
  'onlineGPWebpayPaymentEnabled',
  'directTransferPaymentEnabled'
]

// If onlineManualPayment is enabled, we need to ensure payment page is visible
// Because it has an associated link and input
// So 'PAYMENT_TYPES.onlineManual' is not skippable payment type
export const skippablePaymentTypes = [
  PAYMENT_TYPES.online.id,
  PAYMENT_TYPES.payPal.id,
  PAYMENT_TYPES.globalPayments.id,
  PAYMENT_TYPES.globalPaymentsWebpay.id
]

export const wizard = Object.keys(steps).map(item => {
  const currentStep = steps[item]

  let allowedPaths = currentStep.allowedPaths.concat(currentStep.next)

  allowedPaths = currentStep.allowedPaths.map(
    allowedPath =>
      allowedPath.startsWith('//')
        ? allowedPath.substring(1)
        : rootPath + allowedPath
  )

  return {
    id: currentStep.id,
    label: currentStep.label,
    completed: false,
    active: currentStep.active,
    intlKey: currentStep.intlKey,
    next: rootPath + currentStep.next,
    path: rootPath + currentStep.path,
    rootPath,
    allowedPaths
  }
})
